<div class='m-16'>
  @if (loading) {
    <mat-progress-bar mode='indeterminate'></mat-progress-bar>
  }
  <mat-accordion>
    @for (tourOperator of tourOperators; track trackByIndex($index, tourOperator)) {
      <integration-block
        [tourOperator]="tourOperator"
        (reload)="loadTourOperators($event)"
        (updated)="integrationUpdated($event, tourOperator)"
        (create)="createTripPackageIntegration(tourOperator)"
      ></integration-block>
    }
  </mat-accordion>
</div>
